import { FC } from "react";
import styles from "./highlight-star-box.module.css";

interface HighlightStarBoxProps {
  className?: string;
}

const HighlightStarBox: FC<HighlightStarBoxProps> = ({ className }) => {
  return (
    <div className={`${styles.highlightStarBoxWrapper} ${className}`}>
      <span className='icon-star-fill' />
    </div>);

};

export default HighlightStarBox;